export enum EActivity {
  STUDIO_LOADED = 'UA-1-0', // sent when the studio is loaded
  WELCOME_TOUR_INIT = 'UA-1-3', // sent when the welcome tour is initialized
  WELCOME_TOUR_END = 'UA-1-4', // sent when the welcome tour is finished
}

export function log(AID: string, meta?: any) {
  fetch('/api/v1/activity', {
    body: JSON.stringify({
      AID,
      ...meta,
    }),
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
  }).catch((_e) => {
    // do nothing
  });
}

export function trackEvent(event: string) {
  window.pagesense = window.pagesense || [];
  window.pagesense.push(['trackEvent', event]);
}
